try {
  window.$ = window.jQuery = require('../../../node_modules/jquery/dist/jquery.slim');
} catch (e) {}